/**
 * Shared RTK Query baseQuery that delegates to the authenticated apiClient.
 * Used by the createApi slices (trends, onboarding, subscription, …) so the
 * request-building and error-normalisation logic lives in one place.
 */

import { apiClient } from '@/auth';

export interface BaseQueryArgs {
    url: string;
    method?: 'GET' | 'POST';
    body?: unknown;
    params?: Record<string, unknown>;
}

export const apiClientBaseQuery = async (args: BaseQueryArgs) => {
    const { url, method = 'GET', body, params } = args;
    try {
        const response = method === 'POST'
            ? await apiClient.post(url, body as Record<string, unknown>)
            : await apiClient.get(url, params);
        return { data: response.data };
    } catch (error: unknown) {
        const apiError = error as { response?: { status?: number; data?: unknown }; status?: number; message?: string };
        return {
            error: {
                status: apiError.response?.status ?? apiError.status ?? 500,
                data: apiError.response?.data ?? apiError.message,
            },
        };
        };
};
